<template>
  <b-card
    :id="indicator.id"
    class="info"
    :class="compact ? 'compact' : ''"
    :style="{ minHeight: height }"
  >
    <h4 v-if="showTitle" class="card-title">
      {{ $t("label_reports_genderGap_indicatorInformation_title") }}
    </h4>
    <h6 class="card-subtitle">
      {{ $t(indicator.acronym) }} - {{ $t(indicator.name) }}
    </h6>
    <p class="card-text">
      <span>{{ $t("label_reports_genderGap_objective_title") }}</span>
      {{ $t(indicator.objective) }}
    </p>
    <div class="indexs">
      <div class="convention">
        <p>
          {{ $t("label_reports_genderGap_pillarIndicator_lettlerhead_title") }}
        </p>
        <div class="index dark">
          {{ $t("label_indicator_" + indicatorId + "_acronym") }}
        </div>
      </div>
      <div class="convention">
        <p>{{ $t("label_reports_genderGap_indicatorValue_caption") }}</p>
        <div
          v-if="indicator.ranges"
          class="index"
          :class="
            getColorStateValue(
              indicator.value,
              indicator.ranges,
              indicator.errorOnValueFormula
            )
          "
        >
          {{ indicator.value | currency("", 2, { thousandsSeparator: "" })
          }}<span v-if="indicator.indicator_value_scale === 'percentage'"
            >%</span
          >
        </div>
      </div>
    </div>
    <div
      v-if="indicator.errorOnIndexFormula == 'true'"
      class="mt-3"
      align="center"
    >
      <p class="card-text">
        {{ $t("label_reports_notEnoughDataIndicator") }}
      </p>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardIndicatorInfoConsolidated",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    indicatorId: {
      type: String,
      default: "PP1",
    },
    height: {
      type: String,
      default: "auto",
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      indicator: {},
      showTitle: true,
      color: "positive",
    };
  },
  computed: mapGetters([
    "getIndicatorDataConsolidated",
    "getColorStateValue",
    "getColorStateIndex",
  ]),
  watch: {
    indicatorId: function () {
      this.indicator = this.getIndicatorDataConsolidated(
        this.pillarId,
        this.indicatorId
      );
    },
  },
  mounted() {
    this.indicator = this.getIndicatorDataConsolidated(
      this.pillarId,
      this.indicatorId
    );
  },
  updated() {
    var offsetHeight = document.getElementById(this.indicator.id).offsetHeight;
    if (offsetHeight > parseInt(this.height.split("px")[0]) + 37) {
      this.showTitle = false;
    }
  },
};
</script>

<style lang="scss" scoped>

/* components/cards/CardIndicatorInfo*/

@import "../../assets/css/variables.scss";
.indexs {
  display: flex;
  justify-content: center;
  .convention {
    font-size: 1rem;
    text-align: center;
    margin: 0 10px;
    font-weight: bold;
    font-family: $font-subtitle;
    width: 175px;
    p {
      margin-bottom: 0;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .index {
      top: 0px;
      padding: 0 10px;
      font-size: 2rem;

      border-radius: 5px;
      color: #ffffff;
      text-align: center;
    }
  }
}
.dark {
  background-color: #000;
}
.compact {
  .card-subtitle {
    font-size: 1rem;
    margin: 0;
  }
  .card-text {
    font-size: 0.8rem;
    margin: 0px;
  }
  .convention {
    font-size: 0.8rem;
    .index {
      font-size: 1.6rem;
    }
  }
}
</style>
